import { Injectable } from '@angular/core';
import { CustomErrorHandler } from '@siza-staff-care/shared/error-handler';
import { GenericDialogsService } from '@siza-staff-care/shared/generic-dialogs';
import { BusinessError } from './business-error';
import { DeleteReferencedDataError } from './delete-referenced-data-error';
import { ObjectNotFoundError } from './object-not-found-error';
import { ServerErrorShownError } from './server-error-shown-error';
import { ServerValidationError } from './server-validation-error';
import { EMPTY } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class GenericErrorHandlerService {
	constructor(
		private genericDialogs: GenericDialogsService,
		private errorHandler: CustomErrorHandler,
	) {}

	handleError(error: unknown, context = '', operation?: string) {
		if (error instanceof BusinessError) {
			this.handleBusinessError(error, context, operation);
		} else if (error instanceof ObjectNotFoundError) {
			this.handleObjectNotFoundError(error, context);
		} else if (error instanceof DeleteReferencedDataError) {
			this.handleDeleteReferencedDataError(error, context);
		} else if (error instanceof ServerValidationError) {
			this.handleServerValidationError(error, context);
		} else if (error instanceof ServerErrorShownError) {
			// Do nothing - the error has already been shown to the user
		} else {
			this.handleOtherError(error, context);
		}

		return EMPTY;
	}

	handleDeleteReferencedDataError(error: DeleteReferencedDataError, context: string) {
		const msg = `The ${context.toLowerCase()} is referenced by the following data`;
		this.genericDialogs.showDeleteReferencedData(msg, error.items, `${context} cannot be deleted`);
	}

	handleServerValidationError(error: ServerValidationError, context: string) {
		this.genericDialogs.message(error.message, `${context} validation error`);
	}

	handleObjectNotFoundError(error: ObjectNotFoundError, context: string) {
		this.genericDialogs.message(error.message, `${context} not found`);
	}

	handleBusinessError(error: BusinessError, context: string, operation?: string) {
		let messages = error.message;
		let multipleMessages = false;
		if (error.messages.length > 1) {
			messages = `<ul><li>${error.messages.join('</li><li>')}</li></ul>`;
			multipleMessages = true;
		}

		if (operation) {
			this.genericDialogs.message(messages, `${operation} this ${context} failed.`, {
				asHtml: multipleMessages,
				maxWidth: '100ch',
			});
			return;
		}

		const title = error.message.includes('duplicate') ? `Duplicate ${context.toLowerCase()}` : 'Error';
		this.genericDialogs.message(messages, title, {
			asHtml: multipleMessages,
			maxWidth: '100ch',
		});
	}

	handleOtherError(error: unknown, context: string) {
		// Log error  - this is unhandled, so should go to Raygun
		this.errorHandler.handleErrorFromGenericErrorHandler(error, context);
	}
}
